import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { LangProvider } from "@/LangContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Ecosystem from "@/components/Ecosystem";
import Transformation from "@/components/Transformation";
import Masterplan from "@/components/Masterplan";
import NamingRights from "@/components/NamingRights";
import Governance from "@/components/Governance";
import Contribute from "@/components/Contribute";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import PaymentResult from "@/pages/PaymentResult";
import BidderPortal from "@/pages/BidderPortal";
import Admin from "@/pages/Admin";
import Auction from "@/components/Auction";
import { scrollToId } from "@/lib/scroll";

function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    if (hash) setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [hash]);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#0A0C10] font-body text-slate-100 antialiased">
      <div className="bg-noise" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Ecosystem />
        <Transformation />
        <Masterplan />
        <NamingRights />
        <Auction />
        <Governance />
        <Contribute />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route path="/subasta" element={<BidderPortal />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </LangProvider>
  );
}

export default App;
